import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';
import { ReactComponent as Track } from '@styles/icons/track.svg';
import React from 'react';

export const TrackIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} component={Track} viewBox={'0 0 20 20'} />
);

export default TrackIcon;
